module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "container",
    staticStyle: {
      "background-repeat": "no-repeat",
      "background-size": "cover",
      "background-image": "url(./img/fd_bloc.jpg)"
    }
  }, [_c('div', {
    staticClass: "box_blocs"
  }, [_c('div', {
    directives: [{
      name: "lang",
      rawName: "v-lang.revolution",
      modifiers: {
        "revolution": true
      }
    }],
    staticClass: "bloc5 scrollListner slide"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "lang",
      rawName: "v-lang.sans-abo",
      modifiers: {
        "sans-abo": true
      }
    }],
    staticClass: "bloc1 scrollListner slide2"
  }), _vm._v(" "), _c('img', {
    staticClass: "visu4 scrollListner slide",
    attrs: {
      "border": "0",
      "alt": "visu4",
      "src": "img/visu4.png"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "lang",
      rawName: "v-lang.nouveau-canal",
      modifiers: {
        "nouveau-canal": true
      }
    }],
    staticClass: "bloc1_right scrollListner slide"
  }), _vm._v(" "), _c('img', {
    staticClass: "visu1 scrollListner slide2",
    attrs: {
      "border": "0",
      "alt": "visu1",
      "src": "img/visu1.png"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "lang",
      rawName: "v-lang.experience",
      modifiers: {
        "experience": true
      }
    }],
    staticClass: "bloc2 scrollListner slide"
  }), _vm._v(" "), _c('img', {
    staticClass: "visu2 scrollListner slide2",
    attrs: {
      "border": "0",
      "alt": "visu2",
      "src": "img/visu2.png"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "lang",
      rawName: "v-lang.nb-client",
      modifiers: {
        "nb-client": true
      }
    }],
    staticClass: "bloc3 scrollListner slide2"
  }), _vm._v(" "), _c('img', {
    staticClass: "visu3 scrollListner slide2",
    attrs: {
      "border": "0",
      "alt": "visu3",
      "src": "img/visu3.png"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "lang",
      rawName: "v-lang.nb-commande",
      modifiers: {
        "nb-commande": true
      }
    }],
    staticClass: "bloc3 bis scrollListner slide"
  }), _vm._v(" "), _c('img', {
    staticClass: "visu6 scrollListner slide-left",
    attrs: {
      "border": "0",
      "alt": "visu6",
      "src": "img/visu6.png"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "lang",
      rawName: "v-lang.plateforme",
      modifiers: {
        "plateforme": true
      }
    }],
    staticClass: "bloc2_right scrollListner slide-right"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "lang",
      rawName: "v-lang.reference",
      modifiers: {
        "reference": true
      }
    }],
    staticClass: "bloc3_right scrollListner slide"
  }), _vm._v(" "), _c('img', {
    staticClass: "visu5 scrollListner slide",
    attrs: {
      "border": "0",
      "alt": "visu5",
      "src": "img/visu5.png"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "lang",
      rawName: "v-lang.autonomie",
      modifiers: {
        "autonomie": true
      }
    }],
    staticClass: "bloc3_right2 scrollListner slide"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "lang",
      rawName: "v-lang.simple-intuitif",
      modifiers: {
        "simple-intuitif": true
      }
    }],
    staticClass: "bloc4 scrollListner slide"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "lang",
      rawName: "v-lang.unique",
      modifiers: {
        "unique": true
      }
    }],
    staticClass: "bloc4 bis scrollListner slide"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "lang",
      rawName: "v-lang.garantie",
      modifiers: {
        "garantie": true
      }
    }],
    staticClass: "bloc6 scrollListner slide"
  })])]), _vm._v(" "), (_vm.locale == 'fr') ? _c('section', {
    staticClass: "section_presse"
  }, [_vm._m(0)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container center-text"
  }, [_c('h1', [_vm._v("La presse en parle :")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-large marg_r20",
    attrs: {
      "onclick": "window.open('http://www.opticien-presse.fr/2017/10/17/supervision-lance-1ere-marketplace-de-loptique-b-to-b/')"
    }
  }, [_vm._v("L'ol mag")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-large marg_r20",
    attrs: {
      "onclick": "window.open('./img/sv-lol.pdf')"
    }
  }, [_vm._v("L'ol mag (pdf)")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-large marg_r20",
    attrs: {
      "onclick": "window.open('http://www.frequenceoptic.fr/actualites/thierry-frediani-avec-notre-marketplace-btob-nous-ouvrons-un-canal-de-distribution-inedit.html')"
    }
  }, [_vm._v("Fréquence Optique")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-large",
    attrs: {
      "onclick": "window.open('https://www.lesechos-etudes.fr/news/2017/11/02/supervision-annonce-la-creation-dune-nouvelle-place-de-marche-en-optique-btob')"
    }
  }, [_vm._v("Les Echos")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28306f36","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/Body.vue
// module id = 51
// module chunks = 0